import { Icon } from '@iconify/react';
import { addMonths, isAfter, startOfMonth, subMonths } from 'date-fns';
import { useMonthlyReportStore } from '../../../store/reportStore';

/*
 * 월 네비게이터
 * 이전 월, 다음 월을 이동할 수 있다.
 * 이전 월, 다음 월은 현재 월보다 이전인 경우 비활성화된다.
 */
const MonthNavigator = () => {
  const { selectedMonth, setSelectedMonth } = useMonthlyReportStore();
  const today = new Date();
  const isDisabled = isAfter(selectedMonth, startOfMonth(today));

  /**
   * 이전 월로 이동
   */
  const prevMonth = () => {
    setSelectedMonth(subMonths(selectedMonth, 1)); // 이전 월로 이동
  };

  /**
   * 다음 월로 이동
   */
  const nextMonth = () => {
    setSelectedMonth(addMonths(selectedMonth, 1));
  };

  return (
    <div style={{ marginTop: 20, width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Icon icon="bi:arrow-left-circle-fill" onClick={prevMonth} style={{ marginRight: 4, cursor: 'pointer' }} />
        {isDisabled ? (
          <Icon icon="bi:arrow-right-circle-fill" style={{ color: '#eee' }} /> //
        ) : (
          <Icon icon="bi:arrow-right-circle-fill" onClick={nextMonth} style={{ cursor: 'pointer' }} />
        )}
      </div>
    </div>
  );
};

export default MonthNavigator;
